/**
 * The per-block phone icons pinned to the top-left corner of a merged cell. The counter grid
 * and the officer grid are pivots of each other, so both draw them from the same blocks and
 * the same acknowledged set (useCallAcks): ticking one is ticking the other.
 */
import { CallPhoneButton } from '@/components/CallPhoneButton';
import { ackKey, type CallBlock } from '@/utils/callBlocks';
import { callIcons, type CallGridView, type CallIconRect } from '@/utils/callIcons';

/** One phone icon per call block, pinned to the top-left corner of its merged cell. */
export function CallPhoneOverlay({
  blocks, acked, rects, canEdit, onToggle, view = 'counter',
}: {
  blocks: CallBlock[];
  acked: Set<string> | undefined;
  rects: CallIconRect[];
  canEdit: boolean;
  onToggle: (block: CallBlock, called: boolean) => void;
  view?: CallGridView;
}) {
  return (
    <>
      {callIcons(blocks, rects, view).map(({ block, rect, size }) => {
        const done = !!acked?.has(ackKey(block.officerId, block.signature));
        return (
          <CallPhoneButton
            key={`${block.officerId}|${block.signature}`}
            active={!done}
            size={size}
            disabled={!canEdit}
            title={!canEdit
              ? 'View only — switch to Edit to tick'
              : done ? 'Informed ✓ — click to undo' : 'Call this officer about the change, then click to mark informed'}
            onClick={() => onToggle(block, !done)}
            // Below the sticky label column (2) and time header (3), so scrolling hides it with its cell.
            style={{ position: 'absolute', left: rect.x + 1, top: rect.y + 1, zIndex: 1 }}
          />
        );
      })}
    </>
  );
}
